import type { ApiResponse } from "@/types";
import {
  type UseQueryResult,
  queryOptions,
  useQuery,
} from "@tanstack/react-query";
import type { AgentTask } from "../../../schemas/codegen";
import { api } from "../api/api";
import { QUERY_KEYS } from "./queryKeys";

export function getTasksQueryOptions(chatId: string) {
  return queryOptions({
    queryKey: [QUERY_KEYS.TASKS, chatId],
    queryFn: () => api.listTasks(chatId),
    select: (
      response: ApiResponse<{
        tasks: AgentTask[];
      }>,
    ) => response.data.tasks,
  });
}

export function useTasks(chatId?: string): UseQueryResult<AgentTask[], Error> {
  return useQuery<ApiResponse<{ tasks: AgentTask[] }>, Error, AgentTask[]>({
    queryKey: [QUERY_KEYS.TASKS, chatId],
    queryFn: () => {
      if (!chatId) {
        throw new Error("Chat ID is required");
      }
      return api.listTasks(chatId);
    },
    enabled: !!chatId,
    select: (response) => response.data.tasks,
  });
}
